import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ZimbraHero from '../components/zimbra-admin-panel/ZimbraHero';
import StatsBar from '../components/zimbra-admin-panel/StatsBar';
import AdminFeatures from '../components/zimbra-admin-panel/AdminFeatures';
import CustomerFeatures from '../components/zimbra-admin-panel/CustomerFeatures';
import HowItWorks from '../components/zimbra-admin-panel/HowItWorks';
import TechStack from '../components/zimbra-admin-panel/TechStack';
import MultilingualSection from '../components/zimbra-admin-panel/MultilingualSection';
import ScreenshotShowcase from '../components/zimbra-admin-panel/ScreenshotShowcase';
import ThemeToggle from '../components/zimbra-admin-panel/ThemeToggle';
import AICapabilities from '../components/ai/AICapabilities';

const ZimbraAdminPanelPage = () => {
  const [isDark, setIsDark] = useState(true);
  const { t } = useTranslation('zimbra-admin-panel');
  const { t: tEditor } = useTranslation('editor');

  return (
    <div className={isDark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-slate-950 transition-colors duration-300">
        <div className="fixed top-0 left-0 right-0 z-50">
          <Navbar />
        </div>

        <div className="pt-20">
          <ZimbraHero />
        </div>
        <StatsBar />
        <AdminFeatures />
        <CustomerFeatures />
        <HowItWorks />
        <AICapabilities accent="from-indigo-500 to-purple-600" productName="Zimbra Admin Panel" />
        <TechStack />
        <MultilingualSection />
        <ScreenshotShowcase />

        <section className="py-20 bg-gradient-to-r from-indigo-600 to-cyan-600 dark:from-indigo-700 dark:to-cyan-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl md:text-4xl font-bold text-white mb-6"
            >
              {t('cta.title')}
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-xl text-indigo-100 mb-8"
            >
              {t('cta.subtitle')}
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-indigo-600 rounded-lg font-semibold hover:bg-indigo-50 transition-colors shadow-xl"
              >
                {t('cta.demo')}
                <ArrowRight className="h-5 w-5" />
              </Link>
              <Link
                to="/products"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors"
              >
                {tEditor('productPage.allProducts')}
              </Link>
            </motion.div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default ZimbraAdminPanelPage;
